<template>
    <v-card>
        <v-container>
            <v-row>
                <v-col cols="12" lg="3">
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        :label="$vuetify.lang.t('$vuetify.screenshots.search')"
                        outlined
                    ></v-text-field>
                    <v-navigation-drawer height="720" width="100%" permanent>
                        <v-treeview
                            ref="tree"
                            item-key="name"
                            dense
                            hoverable
                            activatable
                            open-on-click
                            transition
                            return-object
                            :items="items"
                            :search="search"
                            :active.sync="active"
                            :open="filteredItems"
                            @update:active="onUpdateActive"
                        >
                            <template v-slot:prepend="{ open, leaf }">
                                <v-icon>
                                {{ leaf ? 'mdi-file-image' : open ? 'mdi-folder-open' : 'mdi-folder' }}
                                </v-icon>
                            </template>
                            <template v-slot:label="node">
                                <div>{{ prepareNodeLabel(node) }}</div>
                            </template>
                        </v-treeview>
                        <div v-if="filteredItems.length === 0 && search !== ''" class="text-h6 grey--text text--lighten-1 font-weight-light">
                            No data
                        </div>
                    </v-navigation-drawer>
                </v-col>
                <v-spacer></v-spacer>
                <v-col :cols="selected && selected.loading ? 'auto' : ''" :align-self="selected && !selected.loading ? 'start' : 'center'">
                    <ScreenshotDetailsCard v-if="selected && !selected.loading" :screenshot="selected"/>
                    <v-progress-circular v-else-if="selected && selected.loading" indeterminate color="rgba(62,143,197,1)" size="50" width="6"></v-progress-circular>
                    <div v-else class="text-h6 text-center grey--text text--lighten-1 font-weight-light">
                        {{ $vuetify.lang.t('$vuetify.screenshots.selectascreenshot') }}
                    </div>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
const today = new Date()
import axios from 'axios';
import { mapGetters } from 'vuex';
import ScreenshotDetailsCard from './Screenshots/ScreenshotDetailsCard.vue';
var tiff = require('tiff');

export default {
    name: "Screenshots",
    components: {
        ScreenshotDetailsCard,
    },
    data() {
        return {
            months: ['$vuetify.screenshots.january', '$vuetify.screenshots.february', '$vuetify.screenshots.march', '$vuetify.screenshots.april', '$vuetify.screenshots.may', '$vuetify.screenshots.june', '$vuetify.screenshots.july', 
            '$vuetify.screenshots.august', '$vuetify.screenshots.september', '$vuetify.screenshots.october','$vuetify.screenshots.november', '$vuetify.screenshots.december'],
            active: [],
            currentYearChildren: [],
            pastYearChildren: [],
            oldChildren : [],
            images: [],
            search: "",
        }
    },
    computed: {
        ...mapGetters({ user: "StateUser" }),

        items() {
            return [
                {
                    name: "" + today.getFullYear(),
                    children: this.currentYearChildren,
                    root: true
                },
                {
                    name: "" + (today.getFullYear() -1),
                    children: this.pastYearChildren,
                    root: true
                },
                {
                    name: this.$vuetify.lang.t('$vuetify.screenshots.before')  +' '+ Number(today.getFullYear() - 1) + ' : ' + this.oldChildren.length +' '+ this.$vuetify.lang.t('$vuetify.screenshots.screenshots'),
                    children: this.oldChildren,
                    root: true
                },
            ]
        },
        selected() {
            return this.active.length > 0 && !('children' in this.active[0]) ? this.active[0] : undefined;
        },
        filteredItems() {
            return this.search === "" ? [] : Object.values(this.$refs.tree.nodes).filter(node => !this.$refs.tree.excludedItems.has(node.item.name)).map(node => node.item);
        },
    },
    watch: {
        selected(newSelected) {
            if (newSelected !== undefined && newSelected.loading) {
                this.getImageBlob(newSelected);
            }
        }
    },
    mounted() {
        this.getImageList();
    },
    methods: {
        compareFileDate(fileA, fileB) { // filename must be written in this pattern : 99999.Z_yyyymmdd_hhmmss.[jpg | tiff]
            return - fileA.name.substring(8, 23).localeCompare(fileB.name.substring(8, 23)) // compare on date and hour only
        },
        prepareNodeLabel(node) {
            if (!('root' in node.item) && !node.leaf) {
                let newLength = this.$refs.tree.nodes[node.item.name].children.filter(child => child.toLocaleLowerCase().indexOf(this.search.toLocaleLowerCase()) > -1).length;
                let newName = node.item.name.replace(/\d+/, newLength);
                if (newLength <= 1) newName = newName.replace(/screenshot(s)?/, "screenshot");
                return newName;
            }
            return node.item.name;
        },
        async getImageList() {
            try {
                const res = await axios.get('images/screenshotsGrp/'+this.user.orga);
                if (res.status == 200) {
                    let images = res.data;

                    images.sort(this.compareFileDate);

                    let currentYearChildren = [], pastYearChildren = [], oldChildren = [];

                    for (let i = 0; i < today.getMonth() + 1; i++) {
                        currentYearChildren.push({
                            name: "",
                            children: []
                        })
                    }
                    for (let i = 0; i < 12; i++) {
                        pastYearChildren.push({
                            name: "",
                            children: []
                        })
                    }
    
                    for (const im in images) {
                        if (images[im].name.substring(8, 12) == today.getFullYear()) {
                            currentYearChildren[currentYearChildren.length - 1 - (images[im].name.substring(12, 14) - 1)].children.push(images[im]);
                        } else if (images[im].name.substring(8, 12) == today.getFullYear() - 1) {
                            pastYearChildren[pastYearChildren.length - 1 - (images[im].name.substring(12, 14) - 1)].children.push(images[im]);
                        } else {
                            oldChildren.push(images[im]);
                        }
                    }
    
                    currentYearChildren.forEach((child, index) => {
                        child.name = this.$vuetify.lang.t(this.months[currentYearChildren.length - 1 - index]) + " : " + child.children.length +' '+ this.$vuetify.lang.t('$vuetify.screenshots.screenshots');
                    })
                    pastYearChildren.forEach((child, index) => {
                        child.name = this.$vuetify.lang.t(this.months[pastYearChildren.length - 1 - index]) + " : " + child.children.length +' '+ this.$vuetify.lang.t('$vuetify.screenshots.screenshots');
                    })
    
                    this.currentYearChildren = currentYearChildren;
                    this.pastYearChildren = pastYearChildren;
                    this.oldChildren = oldChildren;
    
                    this.images = images;
                }
                this.loading = false;
            }
            catch(error){
                console.error(error)
            }
        },
        async getImageBlob(image) {
           try { 
                const res = await axios.get('images/screenshots/' + image.name + '/'+ this.user.orga , { responseType: 'blob' });
                if (res.status === 200) {
                    const blob = res.data;
                    const objectUrl = URL.createObjectURL(blob);
                    image.blob = blob;
                    image.arraybuffer = await blob.arrayBuffer();
                    try {
                        image.tiff = tiff.decode(image.arraybuffer);
                    } catch (err) {
                        image.tiff = undefined;
                    }
                    image.url = objectUrl;
                }
            } catch(error) {
                if (error.code !== "ECONNABORTED") console.error(error)
            }
            setTimeout(() => {
                image.loading = false;
            }, 300)
        },
        async onUpdateActive() {
            if (!this.selected) {
                this.active = [];
            }
        },
    },   
}
</script>